export function browserDownload(url: string, name: string) {
  const link = document.createElement('a');
  link.href = url;
  link.download = name || 'downloaded-file';
  link.target = '_blank';
  link.rel = 'noopener noreferrer';
  document.body.appendChild(link);

  link.click();

  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}

export function downloadBlob(blob: Blob, filename: string) {
  const url = window.URL.createObjectURL(blob);
  browserDownload(url, filename);
}
